import { mounterFor } from "./util";
import Type from "union-type"; //https://www.npmjs.com/package/union-type
import * as R from "ramda"; //https://www.npmjs.com/package/ramda
import Question from "./question";
import { h } from "snabbdom"; //https://www.npmjs.com/package/snabbdom
import globalState from "./globalState";
import { isStaging } from "../formatters-custom";

// Tracking
import { track } from "../tracking/utils";

const container = document.querySelector(".js-survey");

const GlobalQuestion = globalState.withGlobalState(Question);

// STATE
// {
//   queryBase: string
//   vertical: string
//   questions: []question
//   activeQuestion: int
//   isMobile: bool
// }

const init = () => {
  // Tracking on initial page load
  setTimeout(() => {
    track({ cbpgFunction: "qualificationquestion" }, true);
  }, 500);

  const surveyConfig = JSON.parse(
    document.querySelector("#survey-config").dataset.data
  );
  for (const q of surveyConfig.questions) {
    q.options = (q.options || []).map((opt) => {
      if (typeof opt === "string") {
        return { text: opt, details: "", selected: false };
      }
      return { ...opt, selected: false };
    });
  }
  return {
    ...surveyConfig,
    activeQuestion: 0,
  };
};

const Action = Type({
  MoveRight: [],
  MoveLeft: [],
  UpdateQuestion: [Object],
});

function getQuestionValue(question) {
  if (question.type === "text") return question.response;
  return question.options
    .filter((opt) => opt.selected)
    .map((opt) => opt.text)
    .join(", ");
}

/**
 * We are mapping only the last question to its corresponding facet.
 * This will create a map with the selected answer from the final question
 * that will be added as a query param in the url once the user clicks submit
 */
function constructQuery(state) {
  let facets = { '$and': [] };
  let reasonOptions = [];

  const serviceCodeMap = {
    'Build your financial plan': 'O1',
    'Grow your wealth': 'O2',
    'Plan for a child’s education': 'O3',
    'Safeguard your savings': 'O4',
    'Protect your family and transition your wealth': 'O5',
    'Other': '6',
  };

  for (const question of state.questions) {
    const facetName = question.facet;
    const facetValue = getQuestionValue(question);

    if (facetName === "c_wealthAdvisorMeetingType") {
      continue;
    }

    if (facetValue != "" && facetValue != undefined) {
      const splitFacetValues = facetValue.split(", ");
      // Add to reasonOptions
      if (facetName === "c_wealthAdvisorServices") {
        for (const splitFacetValue of splitFacetValues) {
          const mappedValue = serviceCodeMap[splitFacetValue];
          if (mappedValue) {
            reasonOptions.push(mappedValue);
          }
        }
      } else {
        // Add to facets
        for (let splitFacetValue of splitFacetValues) {
          if (splitFacetValue != "") {
            facets["$and"].push({
              [facetName]: {
                $eq: splitFacetValue,
              },
            });
          }
        }
      }
    }
  }
  return {
    facets: JSON.stringify(facets),
    reasonOptions: reasonOptions.join(','),
  };
}


function handleTracking(state) {
  let cbpgFunction = "";
  switch (state.activeQuestion) {
    case 0:
      cbpgFunction = "qualificationquestion";
      break;
    case 1:
      cbpgFunction = "qualificationquestion-meetingprefer";
      break;
    case 2:
      cbpgFunction = "qualificationquestion-assets";
      break;
    default:
      cbpgFunction = "";
      break;
  }

  if (cbpgFunction) {
    setTimeout(() => {
      track({ cbpgFunction: cbpgFunction }, true);
    }, 500);
  }
}

// https://ramdajs.com/docs/#curry <--- documentation on curry function used from ramda node module
// surveyView handles the front end for the entire survey
const surveyView = R.curry((action$, state) => {
  const { facets, reasonOptions } = constructQuery(state)
  const queryParams = new URLSearchParams({
    survey: "true",
    filters: facets,
    reasonOptions: reasonOptions,
  });
  const queryUrl = `/${state.vertical}?${queryParams.toString()}`;
  const defaultFacet = {"$and":[{"c_FALocatorAssetRangev2":{"$eq":"$500,000 - $2,999,999"}}]};
  const defaultQueryParams = new URLSearchParams({
    survey: "true",
    filters: JSON.stringify(defaultFacet),
  });
  const defaultQueryUrl = `/${state.vertical}?${defaultQueryParams.toString()}`;
  
  //adding one to state here so doesn't interact with form input, checkbox will be length of questions + 1
  const submitButton = h(
    "a.Survey-submit",
    {
      on: {
        click: (e) => {
          e.preventDefault();
          const event = new ANSWERS.AnalyticsEvent("CTA_CLICK").addOptions({
            directAnswer: false,
            searcher: "UNIVERSAL",
            verticalKey: "universal",
            ctaLabel: "GS_Find_An_Advisor",
            entityId: "GuidedSearch", //hardcoded entity id
          });
          ANSWERS.core._analyticsReporter.report(event);

          if (state.activeQuestion === 2) {
            const selectedOption = state.questions[2].options.filter(
              (opt) => opt.selected
            );
            if (selectedOption && selectedOption[0]) {
              track({ cbinvestableassets: selectedOption[0].analyticsLabel });
            } else {
              track({ cbinvestableassets: "" });
            }
          }

          // go to find an expert page if asset range is 0 to 500k
          if (state.questions[state.questions.length - 1].options[0].selected) {
            if (isStaging("answers-citizenswealth-pagescdn-com.preview.pagescdn.com")) {
              window.location.href = "https://fa_citizensbank_com.yextpages.net/find-an-expert.html?assets=0to500";
            } else {
              window.location.href = "https://fa.citizensbank.com/find-an-expert.html?assets=0to500";
            }
          } else {
            window.location.href = queryUrl;
          }
        }
      },
      props: { href: queryUrl },
    },
    ["FIND AN ADVISOR"]
  );
  const skipButton = h(
    "a.Survey-skip",
    {
      on: {
        click: () => {
          const event = new ANSWERS.AnalyticsEvent("CTA_CLICK").addOptions({
            directAnswer: false,
            searcher: "UNIVERSAL",
            verticalKey: "universal",
            ctaLabel: "GS_Skip",
            entityId: "GuidedSearch", //hardcoded entity id
          });
          ANSWERS.core._analyticsReporter.report(event);
          const skipCardEvent = new ANSWERS.AnalyticsEvent(
            "CTA_CLICK"
          ).addOptions({
            directAnswer: false,
            searcher: "UNIVERSAL",
            verticalKey: "universal",
            ctaLabel: `Skips on card ${state.activeQuestion + 1}`,
            entityId: "GuidedSearch", //hardcoded entity id
          });
          ANSWERS.core._analyticsReporter.report(skipCardEvent);
        },
      },
      props: { href: defaultQueryUrl}
    },
    ["SKIP TO LOCATOR"]
  );
  const rightButton = h(
    "button.Survey-right",
    {
      on: {
        click: () => {
          action$(Action.MoveRight);
          handleTracking(state);
        },
      },
      class: { cbensightenevent: true },
      attrs: { "cbdata-type": "button", "cbdata-reason": "next-question" },
      props: { type: "button" },
    },
    ["NEXT"]
  );
  const isFirstQuestion = state.activeQuestion === 0;
  const isLastQuestion = state.activeQuestion === state.questions.length - 1;

  return h("div.Survey", [
    h("form.Survey-title", ["FIND AN ADVISOR"]),
    h("form.Survey-form", [
      h("div.Survey-question", {}, [
        GlobalQuestion.view(
          (action) =>
            action$(
              Action.UpdateQuestion({
                idx: state.activeQuestion,
                action: action,
              })
            ),
          state.questions[state.activeQuestion]
        ),
      ]),
    ]),
    h("div.Survey-navBar", {}, [
      h("div.Survey-buttons", [
        isFirstQuestion
          ? h("span")
          : h(
              "button.Survey-left",
              {
                style: { marginRight: "16px" },
                on: {
                  click: () => {
                    action$(Action.MoveLeft);
                    handleTracking(state);
                  },
                },
                class: { cbensightenevent: true },
                attrs: {
                  "cbdata-type": "button",
                  "cbdata-reason": "previous-question",
                },
                props: { type: "button" },
              },
              ["PREVIOUS"]
            ),
        isLastQuestion ? submitButton : rightButton,
      ]),
      skipButton,
      h("div.Survey-progressWrapper", {}, [
        h("div.Survey-progress", {}, [
          h(
            "div.Survey-progressFill",
            {
              style: { width: `${100 * (state.activeQuestion >= 0 ? 1 : 0)}%` },
            },
            []
          ),
        ]),
        h("div.Survey-progress", {}, [
          h(
            "div.Survey-progressFill",
            {
              style: { width: `${100 * (state.activeQuestion >= 1 ? 1 : 0)}%` },
            },
            []
          ),
        ]),
        h("div.Survey-progress", {}, [
          h(
            "div.Survey-progressFill",
            {
              style: { width: `${100 * (state.activeQuestion >= 2 ? 1 : 0)}%` },
            },
            []
          ),
        ]),
      ]),
    ]),
  ]);
});

const update = (state, action) => {
  return Action.case(
    {
      MoveLeft: (state) => {
        return {
          ...state,
          activeQuestion: Math.max(0, state.activeQuestion - 1),
        };
      },
      MoveRight: (state) => {
        const event = new ANSWERS.AnalyticsEvent("CTA_CLICK").addOptions({
          directAnswer: false,
          searcher: "UNIVERSAL",
          verticalKey: "universal",
          ctaLabel: "GS_Next_" + (state.activeQuestion + 1),
          entityId: "GuidedSearch", //hardcoded entity id
        });
        ANSWERS.core._analyticsReporter.report(event);
        return {
          ...state,
          activeQuestion: Math.min(
            state.questions.length - 1,
            state.activeQuestion + 1
          ),
          subtitle: "",
        };
      },
      UpdateQuestion: (data, state) => {
        const searchbar = document.querySelector(".js-yext-query");
        const newState = {
          ...state,
          questions: state.questions.map((q, idx) =>
            idx === data.idx ? Question.update(q, data.action) : q
          ),
        };
        if (searchbar) {
          const { facets } = constructQuery(newState);
          searchbar.value = facets;
          searchbar.scrollLeft = searchbar.scrollWidth;
        }
        return newState;
      },
    },
    action,
    state
  );
};

// Sending the update for the updated data stream for the view (frontend) and the user action (MoveLeft, MoveRight, UpdateQuestion)
const surveyMounter = mounterFor({
  view: surveyView,
  update: update,
});

surveyMounter(init(), container);
